import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import PinderNewUserCard from 'components/BriefDetailsClient/PitchBox/PinderNewUserCard';
import styles from './PinderNewTabList.module.scss';
import VisibilitySensor from 'react-visibility-sensor';
import Loader from 'components/Loader/Loader';
import { DEFAULT_PENDING_PITCHES_TO_LOAD } from 'constants/constants';

const PinderNewTabList = ({
  pitches,
  brief,
  pitchListProps,
  handleLike,
  handleDislike,
  loadMore,
  isLoadingMore,
  userCardRef,
}) => {
  const onChange = (isVisible) => {
    if (isVisible) {
      loadMore();
    }
  };

  return (
    <Fragment>
      {pitches.map((currentPitch, index) => {
        if ((index + 1) % DEFAULT_PENDING_PITCHES_TO_LOAD === 2) {
          return (
            <div
              className={styles.userCard}
              key={`pitchbox-newTabList-newTabUserCardContainer-${currentPitch.id}`}
            >
              <VisibilitySensor
                scrollCheck
                delayedCall
                partialVisibility
                onChange={onChange}
              >
                <PinderNewUserCard
                  pitch={currentPitch}
                  userCardRef={userCardRef}
                  brief={brief}
                  pitchListProps={pitchListProps}
                  handleLike={handleLike}
                  handleDislike={handleDislike}
                />
              </VisibilitySensor>
            </div>
          );
        }

        return (
          <div
            className={styles.userCard}
            key={`pitchbox-newTabList-newTabUserCardContainer-${currentPitch.id}`}
          >
            <PinderNewUserCard
              pitch={currentPitch}
              userCardRef={userCardRef}
              brief={brief}
              pitchListProps={pitchListProps}
              handleLike={handleLike}
              handleDislike={handleDislike}
            />
          </div>
        );
      })}
      {isLoadingMore && <Loader loading />}
    </Fragment>
  );
};

PinderNewTabList.propTypes = {
  pitches: PropTypes.array,
  brief: PropTypes.object,
  handleLike: PropTypes.func,
  handleDislike: PropTypes.func,
  loadMore: PropTypes.func,
  isLoadingMore: PropTypes.bool,
};

export default PinderNewTabList;
